import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import ViewAgentScreen from '../component/ViewAgentScreen';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import Constants, { LIMIT } from '../utils/Constants';
import Alert from '../component/alert/alert';
import { HISTORY_DATE_PRESETS, buildHistoryDateParams } from '../component/HistoryDateFilter';

class ViewAgent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            isLoading: false,
            isSrmIpAgent: 0,
            pageNumber: 1,
            totalItems: '',
            list: [],
            showDeleteModal: false,
            deleteItem: null,
            datePreset: 'all',
            fromDate: null,
            toDate: null,
        }
    }
    componentDidMount() {
        const { agentSelectedId, isAgent } = this.props;
        let param = {
            id: agentSelectedId
        }
        const callback = (response) => {
            this.setState({ data: response?.response, isLoading: false })
            let isSrmIpAgent = response?.response?.vendorAgentDetails?.length > 0 ? response?.response?.vendorAgentDetails[0]?.isSrmIpAgent : response?.response?.VendorAgent?.isSrmIpAgent
            this.getCallHistory(isSrmIpAgent)
        }
        this.setState({ isLoading: true })
        this.props.adminAgentDetails(param, callback, isAgent)
    }
    setLoading = (state) => {
        this.setState({ isLoading: state })
    }
    getCallHistory(isSrmIpAgent, pageNumber = 0, dateOverride = {}) {
        const { agentSelectedId, isAgent } = this.props
        const datePreset = dateOverride.datePreset != null ? dateOverride.datePreset : this.state.datePreset;
        const fromDate = dateOverride.fromDate !== undefined ? dateOverride.fromDate : this.state.fromDate;
        const toDate = dateOverride.toDate !== undefined ? dateOverride.toDate : this.state.toDate;
        let param = {
            id: agentSelectedId,
            limit: LIMIT,
            pageNumber,
            isSrmIpAgent: isSrmIpAgent,
            ...buildHistoryDateParams(datePreset, fromDate, toDate),
        }
        const callback = (response) => {
            this.setState({
                list: response?.response?.historys,
                totalItems: response?.response?.totalItems,
                isLoading: false,
                isSrmIpAgent: isSrmIpAgent,
                pageNumber: pageNumber + 1,
                datePreset,
                fromDate,
                toDate,
            })
        }
        this.setState({ isLoading: true })
        if (!isAgent) {
            this.props.vendorAgentCall(param, callback)
        } else {
            this.props.adminAgentCall(param, callback)
        }
    }
    setDateFilter = ({ datePreset, fromDate = null, toDate = null }) => {
        const samePreset = datePreset === this.state.datePreset;
        const sameFrom = (fromDate || null) === (this.state.fromDate || null);
        const sameTo = (toDate || null) === (this.state.toDate || null);
        if (samePreset && sameFrom && sameTo) return;
        this.getCallHistory(this.state.isSrmIpAgent, 0, { datePreset, fromDate, toDate });
    }
    onChangePagination = (pageNumber) => {
        const { agentSelectedId, isAgent } = this.props
        const { isSrmIpAgent, datePreset, fromDate, toDate } = this.state
        let params = {
            id: agentSelectedId,
            pageNumber: (pageNumber - 1),
            limit: LIMIT,
            isSrmIpAgent: isSrmIpAgent,
            ...buildHistoryDateParams(datePreset, fromDate, toDate),
        }
        const callBack = (response) => {
            this.setState({ list: response?.response?.historys, totalItems: response?.response?.totalItems, isLoading: false, pageNumber })
        }
        this.setState({ isLoading: true })
        if (!isAgent) {
            this.props.vendorAgentCall(params, callBack)
        } else {
            this.props.adminAgentCall(params, callBack)
        }
    }
    openDeleteModal = (item) => {
        if (!item?.id) return;
        this.setState({ showDeleteModal: true, deleteItem: item });
    }
    closeDeleteModal = () => {
        this.setState({ showDeleteModal: false, deleteItem: null });
    }
    confirmDeleteHistory = () => {
        const { deleteItem, isSrmIpAgent, pageNumber, datePreset } = this.state;
        if (!deleteItem?.id) {
            this.closeDeleteModal();
            return;
        }
        const params = {
            id: deleteItem.id,
            isSrmIpAgent,
        };
        const callback = (response) => {
            this.closeDeleteModal();
            if (response?.response_code === 0) {
                toast.success(Constants.DELETED_SUCCESSFULLY);
                this.getCallHistory(isSrmIpAgent, Math.max(0, (pageNumber || 1) - 1));
            } else {
                toast.error(response?.response_message || 'Unable to delete history');
                this.setState({ isLoading: false });
            }
        };
        this.setState({ isLoading: true });
        this.props.vendorAgentDeleteHistory(params, callback);
    }
    render() {
        const { data, isLoading, list, pageNumber, totalItems, showDeleteModal, datePreset, fromDate, toDate } = this.state;
        const { isAgent } = this.props;
        const canDeleteHistory = !isAgent;
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <div>
                            <ViewAgentScreen
                                agentData={data}
                                list={list}
                                pageNumber={pageNumber}
                                totalItems={totalItems}
                                onChangePagination={(e) => this.onChangePagination(e)}
                                canDeleteHistory={canDeleteHistory}
                                onDeleteHistory={this.openDeleteModal}
                                datePreset={datePreset}
                                fromDate={fromDate}
                                toDate={toDate}
                                dateFilters={HISTORY_DATE_PRESETS}
                                onDateFilterChange={this.setDateFilter}
                            />
                        </div>
                    </div>
                </div>
                {isLoading && <AppLoader />}
                {canDeleteHistory && showDeleteModal ? (
                    <Alert
                        title={Constants.DELETE_HISTORY_TITLE}
                        description={Constants.DELETE_HISTORY_MSG}
                        proceed={Constants.YES}
                        cancel={Constants.NO}
                        onSuccess={this.confirmDeleteHistory}
                        onFailure={this.closeDeleteModal}
                    />
                ) : null}
            </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {
        agentSelectedId: state?.AGENR_DETAILS?.agentSelectedId?.id,
        isAgent: state?.AGENR_DETAILS?.agentSelectedId?.agent,
        agentState: state?.AGENR_DETAILS
    }
};
export default withRouter(connect(mapStateToProps, {
    adminAgentDetails: Actions.getAdminAgentDetails,
    adminAgentCall: Actions.adminAgentCallHistoryAction,
    vendorAgentCall: Actions.vendorAgentCallHistoryAction,
    vendorAgentDeleteHistory: Actions.vendorAgentDeleteHistoryAction,
})(ViewAgent));
